import { paylines } from "./paylines.config.js";
import { paylineColors } from "./paylineColors.config.js";
import { symbols, paytable, WILD, SCATTER } from "./symbols.config.js";

const BET_VALUES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const COIN_VALUES = [0.01, 0.02, 0.05, 0.10, 0.20, 0.50];
const LINES = paylines.length;

const round2 = (n) => Math.round(n * 100) / 100;

const betsLadder = COIN_VALUES.flatMap((coinValue) =>
    BET_VALUES.map((bet) => ({
        bet,
        coinValue,
        totalBet: round2(bet * coinValue * LINES),
    })),
);

const bets = [...new Set(betsLadder.map((e) => e.totalBet))].sort((a, b) => a - b);

export const slotDefinition = {
    columns: 5,
    rows: 3,
    symbols,
    paytable,
    paylines,
    paylineColors,
    wild: WILD,
    scatter: SCATTER,
    bets,
    betsLadder,
};
